import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import ApplyToAllSitesConfirmModal from './apply_to_all_sites_confirm_modal';
import { delay } from 'lodash';

const STATUS = {
  INITIAL: 'INITIAL',
  APPLYING: 'APPLYING',
  DONE: 'DONE'
};

const MONITOR_INTERVAL_MS = 5000;

export const ApplyTemplateDefaultsToAllSitesButton =
  ({ applying, monitorPath, applyDefaultsToAllSitesPath }) => {
    const [openApplyToAllSitesConfirmModal, setOpenApplyToAllSitesConfirmModal] = useState(false);
    const [status, setStatus] = useState(applying ? STATUS.APPLYING : STATUS.INITIAL);

    useEffect(() => {
      if (status !== STATUS.APPLYING) return;

      function monitor() {
        axios.get(monitorPath).then((response) => {
          if (response.data.status !== 'complete') return;

          setStatus(STATUS.DONE);
          delay(() => setStatus(STATUS.INITIAL), 2000);
        });
      }

      monitor();
      const interval = setInterval(() => monitor(), MONITOR_INTERVAL_MS);

      return () => clearInterval(interval);
    }, [status]);

    let label;
    switch (status) {
    case STATUS.INITIAL:
      label = 'Apply to all sites';
      break;
    case STATUS.APPLYING:
      label = 'Applying...';
      break;
    case STATUS.DONE:
      label = 'Done!';
      break;
    }

    return <div>
      <button
        className={`m-1 btn btn-sm
        ${status === STATUS.DONE ? 'btn-success' : 'btn-default'}`}
        disabled={status === STATUS.APPLYING}
        onClick={() => setOpenApplyToAllSitesConfirmModal(true)}
      >
        {label}
      </button>

      <ApplyToAllSitesConfirmModal confirmPath={applyDefaultsToAllSitesPath}
        open={openApplyToAllSitesConfirmModal} onClose={() => setOpenApplyToAllSitesConfirmModal(false)}
        onConfirm={() => setStatus(STATUS.APPLYING)}
      />
    </div>;
  };

ApplyTemplateDefaultsToAllSitesButton.propTypes = {
  applyDefaultsToAllSitesPath: PropTypes.string,
  applying: PropTypes.bool,
  monitorPath: PropTypes.string
};
